/**
 * @file Newsletter Trigger
 */

/**
 * Newsletter Trigger component
 */
const vNewsletterTrigger = () => {
	const newsletterTrigger = document.querySelectorAll('.v-newsletter-trigger');

	if (!newsletterTrigger) {
		return;
	}

	[...newsletterTrigger].forEach((trigger) => {
		const btn        = trigger.querySelector('.v-newsletter-trigger__submit');
		const target     = document.querySelector(`#${btn.getAttribute('aria-controls')}`);
		const input      = trigger.querySelector('.v-newsletter-trigger__email-input');

		btn.addEventListener('click', () => {
			if (target.getAttribute('data-open') === 'true') {
				return;
			}

			target.setAttribute('data-open', 'trigger');
			trigger.setAttribute('data-trigger', 'true');
		});

		input.addEventListener('input', () => {
			if (input.value) {
				input.classList.add('v-newsletter-trigger__email-input--active');
			} else {
				input.classList.remove('v-newsletter-trigger__email-input--active');
			}
		});

		const triggerObserver = new MutationObserver((list) => {
			list.forEach((record) => {
				if (record.type === 'attributes'
					&& record.attributeName === 'data-trigger'
					&& record.oldValue === 'true'
				) {
					input.value = '';
					input.classList.remove('v-newsletter-trigger__email-input--active');
				}
			});
		});

		triggerObserver.observe(trigger, { attributes: true, attributeFilter: ['data-trigger'], attributeOldValue: true });
	});
};

export default vNewsletterTrigger;
